import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import Tooltip from "@mui/material/Tooltip";

import LibraryContext from "../libraryContext";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import useActiveContexts from "../useActiveContexts";
import { useTranslation } from "react-i18next";
import useClasses from "../../useClasses";

const styles = (theme) => ({
  expandBtn: {
    padding: theme.spacing(1),
  },
  listItem: {
    borderRadius: theme.shape.borderRadius,
  },
});

export default function NavigationItem({ option, openContext, toggleContext }) {
  const classes = useClasses(styles);
  const params = useParams();
  const { handleQuery } = useContext(LibraryContext);
  const { libraryContexts } = useActiveContexts();
  const { t } = useTranslation();
  return (
    <ListItem
      button
      selected={option.id === params?.type}
      onClick={() => {
        //if (mobile) setOpen(false); // TODO: close the temporary navigation on mobile devices after item click
        handleQuery({ type: "navButtonClick", payload: option.id });
      }}
      className={classes.listItem}
    >
      <ListItemIcon>{option.icon}</ListItemIcon>
      <ListItemText>
        <Typography
          variant={option.id === params?.type ? "subtitle2" : "body2"}
          noWrap
        >
          {option.title}
        </Typography>
      </ListItemText>
      {option.id === "contexts" && libraryContexts.length > 0 ? (
        <ListItemSecondaryAction>
          <Tooltip
            title={
              openContext ? t("common.buttons.less") : t("common.buttons.more")
            }
          >
            <IconButton
              edge="end"
              aria-label="expand"
              onClick={toggleContext}
              size="small"
              className={classes.expandBtn}
            >
              {openContext ? (
                <ExpandLessOutlinedIcon fontSize="small" />
              ) : (
                <ExpandMoreOutlinedIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        </ListItemSecondaryAction>
      ) : null}
    </ListItem>
  );
}
